import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const createregistrationRequest = createAsyncThunk(
  'createregistrationRequest',
  async (data, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',

        },
        withCredentials: true,
      };

      const formData = new FormData();
      if (data.coordinator_id) formData.append('coordinator_id', data.coordinator_id);
      if (data.full_name) formData.append('full_name', data.full_name);
      if (data.phone_number) formData.append('phone_number', data.phone_number);
      if (data.course_id)
        formData.append('course_id', data.course_id);
      if (data.email) formData.append('email', data.email);
      if (data.payment_type) formData.append('payment_type', data.payment_type);
      if (data.is_user_exist) formData.append('is_user_exist', data.is_user_exist);
      if (data.amount) formData.append('amount', data.amount);
      if (data.paid_date) formData.append('paid_date', data.paid_date);
      if (data.is_consent) formData.append('is_consent', data.is_consent);
      if (data?.image) formData.append('image', data?.image);

      const response = await axios.post(
        `${PUBLIC_BASE_URL}/course-admissions/create-course-admission`,
        formData,
        config
      );

      if (response.status === 201) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          message: 'Network Error',
          status: 404,
          statusText: err.code,
        });
      } else {
        return rejectWithValue(err.response?.data || 'Unknown error occurred');
      }
    }
  }
);